/**
 * Created by pavel on 6/1/17.
 */
const classesObject = {
  Eyes: class Eyes {
    constructor(firstEye, secondEye) {
      this.firstEye = {
        x: firstEye.x,
        y: firstEye.y
      };
      this.secondEye = {
        x: secondEye.x,
        y: secondEye.y
      };
    }
  },
  Mouth: class Mouth {
    constructor(leftMouthCorner, rightMouthCorner) {
      this.leftMouthCorner = {
        x: leftMouthCorner.x,
        y: leftMouthCorner.y
      };
      this.rightMouthCorner = {
        x: rightMouthCorner.x,
        y: rightMouthCorner.y
      };
    }
  }
};

export default classesObject;



// WEBPACK FOOTER //
// ./src/js/classes.js